import { withResponsiveScreen } from "../common/ResponsiveScreen";
import CreateRoomViewDesktop from "../screens/CreateRoom/ui/CreateRoomViewDesktop";
import CreateRoomViewMobile from "../screens/CreateRoom/ui/CreateRoomViewMobile";
import EtiquetteViewMobile from "../screens/Etiquette/ui/EtiquetteViewMobile";
import EtiquetteViewDesktop from "../screens/Etiquette/ui/EtiquetteViewDesktop";
import PostCallViewMobile from "../screens/PostCall/ui/PostCallMobile";
import PostCallViewDesktop from "../screens/PostCall/ui/PostCallViewDesktop";
import SignInViewMobile from "../screens/Auth/ui/SignInMobileView";
import SignInViewDesktop from "../screens/Auth/ui/SignInViewDesktop";
import SignUpViewMobile from "../screens/Auth/ui/SignUpMobileView";
import SignUpViewDesktop from "../screens/Auth/ui/SignUpViewDesktop";
import CallWebViewMobile from "../screens/Call/ui/CallWebViewMobile";
import CallWebViewDesktop from "../screens/Call/ui/CallWebViewDesktop";
import AllMeetingsViewMobile from "../screens/MeetingsList/ui/mobile/AllMeetingsViewMobile";
import AllMeetingsViewDesktop from "../screens/MeetingsList/ui/desktop/AllMeetingsViewDesktop";
import MyMeetingsViewMobile from "../screens/MeetingsList/ui/mobile/MyMeetingsViewMobile";
import MyMeetingsViewDesktop from "../screens/MeetingsList/ui/desktop/MyMeetingsViewDesktop";
import MeetingsTabsViewMobile from "../screens/MeetingsList/ui/mobile/MeetingsTabsViewMobile";
import MeetingsTabsViewDesktop from "../screens/MeetingsList/ui/desktop/MeetingsTabsViewDesktop";
import EditRoomViewMobile from "../screens/EditRoom/ui/EditRoomViewMobile";
import EditRoomViewDesktop from "../screens/EditRoom/ui/EditRoomViewDesktop";

export const CreateRoomViewAdaptive = withResponsiveScreen(
  CreateRoomViewMobile,
  CreateRoomViewDesktop,
);

export const EtiquetteViewAdaptive = withResponsiveScreen(
  EtiquetteViewMobile,
  EtiquetteViewDesktop,
);

export const PostCallViewAdaptive = withResponsiveScreen(
  PostCallViewMobile,
  PostCallViewDesktop,
);

export const SignInViewAdaptive = withResponsiveScreen(
  SignInViewMobile,
  SignInViewDesktop,
);

export const SignUpViewAdaptive = withResponsiveScreen(
  SignUpViewMobile,
  SignUpViewDesktop,
);

export const CallWebViewAdaptive = withResponsiveScreen(
  CallWebViewMobile,
  CallWebViewDesktop,
);

export const AllMeetingsViewAdaptive = withResponsiveScreen(
  AllMeetingsViewMobile,
  AllMeetingsViewDesktop,
);

export const MyMeetingsViewAdaptive = withResponsiveScreen(
  MyMeetingsViewMobile,
  MyMeetingsViewDesktop,
);

export const MeetingsTabsViewAdaptive = withResponsiveScreen(
  MeetingsTabsViewMobile,
  MeetingsTabsViewDesktop,
);

export const EditRoomViewAdaptive = withResponsiveScreen(
  EditRoomViewMobile,
  EditRoomViewDesktop,
);
